import { userTypes } from "../types";

const initState = {
  loading: false,
  resetPasswordStatus: null,
  userInfo: (localStorage.getItem("userInfo") && JSON.parse(localStorage.getItem("userInfo"))) || {},
  error: null,
};

export function user(state = initState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case userTypes.SIGN_IN_REQUEST:
      return { ...state, loading: true };
    case userTypes.SIGN_IN_SUCCESS:
      return { ...state, loading: false };
    case userTypes.SIGN_IN_FAILURE:
      return { ...state, loading: false };

    case userTypes.LOGIN_REQUEST:
      return { ...state, loading: true };
    case userTypes.LOGIN_SUCCESS:
      return { ...state, loading: false, userInfo: payload };
    case userTypes.LOGIN_FAILURE:
      return { ...state, loading: false, userInfo: {}, error };
    case userTypes.LOGIN_RESET_ERROR: {
      return { ...state, error: null };
    }

    case userTypes.USER_UPDATE_INFO_REQUEST:
      return { ...state, loading: true };
    case userTypes.USER_UPDATE_INFO_SUCCESS:
      return { ...state, loading: false, userInfo: payload };
    case userTypes.USER_UPDATE_INFO_FAILURE:
      return { ...state, loading: false, userInfo: { ...state.userInfo } };

    case userTypes.RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, resetPasswordStatus: "request" };
    case userTypes.RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false, resetPasswordStatus: "success" };
    case userTypes.RESET_PASSWORD_FAILURE:
      return { ...state, loading: false, resetPasswordStatus: "error" };

    case userTypes.LOGOUT:
      return { ...state, loading: false, userInfo: {} };

    default:
      return state;
  }
}
